jQuery( function( $ ) {
	$( '[data-video-id]' ).each( function() {
		const videoBtn = $( this );
		const videoId = $( this ).attr( 'data-video-id' );
		const videoSrc = $( this ).attr( 'data-video-bg-src' );

		if ( videoSrc ) {
			$( this ).css( 'background-image', 'url(' + videoSrc + ')' );
		}

		videoBtn.on( 'click', e => {
			e.preventDefault();

			$( 'body' ).append(
				`<div class="overlay-video" title="Klicka här för att stänga videon">
					<iframe id="player" type="text/html" src="https://www.youtube.com/embed/${ videoId }?enablejsapi=1&origin=http://example.com" frameborder="0"></iframe>
				</div>`
			);
		} );

		$( 'body' ).on( 'click', '.overlay-video', () => {
			const overlay = $( '.overlay-video' );
			overlay.remove();
		} );
	} );
} );
